// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "PageTabs-module--cds--assistive-text--bc6fa";
export var cdsHideFeedback = "PageTabs-module--cds--hide-feedback--52215";
export var cdsShowFeedback = "PageTabs-module--cds--show-feedback--244da";
export var cdsSkeleton = "PageTabs-module--cds--skeleton--76c16";
export var cdsVisuallyHidden = "PageTabs-module--cds--visually-hidden--08bac";
export var link = "PageTabs-module--link--e7bd6";
export var list = "PageTabs-module--list--901c7";
export var listItem = "PageTabs-module--list-item--6ac02";
export var selectedItem = "PageTabs-module--selected-item--ff637";
export var tabsContainer = "PageTabs-module--tabs-container--15bf8";